export default __webpack_public_path__ + "static/media/twitter-new-black-white.ea894edf.svg";